import {
  BoCandidateExperienceModel,
  BoReferenceContactModel,
  ICandidateExperience,
  IEtabCategory,
  IQualification,
  IReferenceContact,
} from "@core/models";

export const CandidatePersonalExperiencesMock1 = {
  [ICandidateExperience.id]: 99,
  [ICandidateExperience.city]: "Paris",
  [ICandidateExperience.extra]: {
    [ICandidateExperience.id]: 3578477,
    [ICandidateExperience.extraFirstname]: "Prénom",
    [ICandidateExperience.extraLastname]: "Nom",
  },
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.endDate]: null,
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.etabName]: "TOTO",
  [ICandidateExperience.id]: 14,
  [ICandidateExperience.isCurrentPosition]: true,
  [ICandidateExperience.postalCode]: "75018",
  [ICandidateExperience.qualification]: { [IQualification.qualificationId]: 2, [IQualification.qualificationLabel]: "Serveur" },
  [ICandidateExperience.rating]: undefined,
  [ICandidateExperience.startDate]: "2020-01-01T00:00:00+00:00",
  [ICandidateExperience.status]: "pending",
  [ICandidateExperience.isSelfVerified]: true,
  [ICandidateExperience.allowVerification]: true,
  [ICandidateExperience.internalComment]: "lorem ipsum",
};

export const CandidatePersonalExperiencesMock2 = {
  [ICandidateExperience.id]: 100,
  [ICandidateExperience.city]: "Paris",
  [ICandidateExperience.extra]: {
    [ICandidateExperience.id]: 3578478,
    [ICandidateExperience.extraFirstname]: "Prénom",
    [ICandidateExperience.extraLastname]: "Nom",
  },
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.endDate]: "2017-06-10T00:00:00+00:00",
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.etabName]: "titi",
  [ICandidateExperience.id]: 15,
  [ICandidateExperience.isCurrentPosition]: false,
  [ICandidateExperience.postalCode]: "75018",
  [ICandidateExperience.qualification]: { [IQualification.qualificationId]: 83, [IQualification.qualificationLabel]: "Agent d'entretien" },
  [ICandidateExperience.rating]: undefined,
  [ICandidateExperience.startDate]: "2016-06-11T00:00:00+00:00",
  [ICandidateExperience.status]: "unverified",
  [ICandidateExperience.isSelfVerified]: false,
  [ICandidateExperience.allowVerification]: false,
  [ICandidateExperience.internalComment]: "",
};

const reference3 = {
  [IReferenceContact.name]: "Jean",
  [IReferenceContact.position]: "Chef de cuisine",
  [IReferenceContact.mail]: "test@extra.com",
  [IReferenceContact.phoneNumber]: "0606060606",
  [IReferenceContact.managerFirstname]: "Brice",
  [IReferenceContact.managerLastname]: "Test",
  [IReferenceContact.managerEmail]: "test@test.fr",
  [IReferenceContact.managerPhoneNumber]: "0123456789",
  [IReferenceContact.managerComment]: "Je recommande vivement ce candidat. Ponctuel et travailleur.",
};

export const CandidatePersonalExperiencesMock3 = {
  [ICandidateExperience.id]: 101,
  [ICandidateExperience.city]: "Paris",
  [ICandidateExperience.extra]: {
    [ICandidateExperience.id]: 3578479,
    [ICandidateExperience.extraFirstname]: "Prénom",
    [ICandidateExperience.extraLastname]: "Nom",
  },
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.endDate]: undefined,
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.etabName]: "Hôtel du centre",
  [ICandidateExperience.id]: 17,
  [ICandidateExperience.isCurrentPosition]: true,
  [ICandidateExperience.postalCode]: "75010",
  [ICandidateExperience.qualification]: { [IQualification.qualificationId]: 83, [IQualification.qualificationLabel]: "Agent d'entretien" },
  [ICandidateExperience.rating]: 5,
  [ICandidateExperience.startDate]: "2010-08-19T00:00:00+00:00",
  [ICandidateExperience.status]: "unverified",
  [ICandidateExperience.isSelfVerified]: true,
  [ICandidateExperience.allowVerification]: false,
  [ICandidateExperience.internalComment]: "lorem ipsum",
  [ICandidateExperience.reference]: new BoReferenceContactModel(reference3),
};

export const boCandidatePersonalExperiencesMocks = [
  CandidatePersonalExperiencesMock1,
  CandidatePersonalExperiencesMock2,
  CandidatePersonalExperiencesMock3,
].map((experience) => new BoCandidateExperienceModel(experience));
